module.exports = __webpack_public_path__ + "img/aaaa.a4404cdc.jpg";